import { Helmet } from 'react-helmet-async';

export function ThankYouPage() {
  return (
    <div className="min-h-screen bg-gray-950 text-yellow-100 flex flex-col items-center justify-center px-6 py-16">
      <Helmet>
        <title>You're In! | PropViper</title>
        <meta name="description" content="Thanks for joining the PropViper Newsletter. Get ready for trading tips, prop firm reviews, and exclusive deals." />
      </Helmet>

      <div className="max-w-xl w-full text-center space-y-6">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-yellow-400">
          You’re In! 🎉
        </h1>

        <p className="text-lg text-yellow-200">
          Thanks for subscribing to PropViper. Check your inbox — fresh trading tips and exclusive prop firm promos are coming your way.
        </p>

        <div className="grid gap-4 sm:grid-cols-2 pt-8">
          <a
            href="/compare"
            className="inline-block bg-yellow-500 hover:bg-yellow-400 text-black px-6 py-3 rounded-lg font-semibold transition-all"
          >
            Compare Prop Firms
          </a>

          <a
            href="/blog"
            className="inline-block border border-yellow-500 text-yellow-300 px-6 py-3 rounded-lg font-semibold hover:bg-yellow-500/10 transition-all"
          >
            Read Latest Guides
          </a>
        </div>

        <p className="text-sm text-gray-400 pt-8">
          Follow us for daily trading thoughts → <a href="https://x.com/thepropviper" target="_blank" className="underline hover:text-yellow-300">@thepropviper</a>
        </p>
      </div>
    </div>
  );
}
